<template>
    <div>
        <!-- 安全级别 -->
        <div class="safe_level">
            <div class="safe_level_msg">
                <div class="level">
                    <div class="level_tit">当前安全级别：</div>
                    <div class="level_line">
                        <span :class="{'safe':phoneMask}"></span>
                        <span :class="{'safe':email||qq_bind||wx_bind}"></span>
                        <span
                        :class="{'safe':(email&&qq_bind)||(email&&wx_bind)||(qq_bind&&wx_bind)}"
                        ></span>
                        <span
                        :class="{'safe':email&&qq_bind&&wx_bind}"
                        ></span>
                    </div>
                    <div class="level_result" 
                    v-if="phoneMask&&!email&&!qq_bind&&!wx_bind">低</div>
                    <div class="level_result" 
                    v-if="(email&&(!qq_bind&&!wx_bind))||(qq_bind&&(!email&&!wx_bind))||(wx_bind)&&(!qq_bind&&!email)">中</div>
                    <div class="level_result"
                    v-if="(email&&qq_bind&&!wx_bind)||(email&&!qq_bind&&wx_bind)||(!email&&qq_bind&&wx_bind)"
                    >高</div>
                    <div class="level_result"
                    v-if="email&&qq_bind&&wx_bind"
                    >安全</div>
                </div>
                <div class="text">建议您通过以下方式提高安全级别，以更好的保护您的交易安全</div>
            </div>
            <div class="safe_level_img">
                <img src="@/assets/img/common/safe_img.png" alt="">
            </div>
        </div>
        <!-- 密码绑定 -->
        <ul class="pwd_upgrade">
            <li class="upgrade_item">
                <div class="account_icon">
                    <img src="@/assets/img/icon/is_certified.png" alt="">
                </div>
                <div class="account_binding">修改密码</div>
                <div class="binding_desc">
                    安全性高的密码可以使账户更安全；互联网账号存在被盗风险，建议您定期更换密码。
                </div>
                <div class="binding_btn">
                    <a href="javascript:;" @click="changePassword">修改</a>
                </div>
            </li>
            <li class="upgrade_item">
                <div class="account_icon">
                    <img src="@/assets/img/icon/is_certified.png" v-if="phoneMask">
                    <img src="@/assets/img/icon/no_certified.png" v-else>
                </div>
                <div class="account_binding">手机绑定</div>
                <div class="binding_desc">
                    您的手机：<span class="phone">{{ phoneMask }}</span>，绑定认证后可用于手机找回密码，接收手机动态密码等。
                </div>
                <div class="binding_btn">
                    <a href="javascript:;" @click="phoneBinding">修改</a>
                </div>
            </li>
            <li class="upgrade_item">
                <div class="account_icon">
                    <img src="@/assets/img/icon/is_certified.png" v-if="this.email">
                    <img src="@/assets/img/icon/no_certified.png" v-else>
                </div>
                <div class="account_binding">邮箱绑定</div>
                <div class="binding_desc" v-if="!email">
                    绑定认证后可用于邮箱找回密码、接收订单提醒等，保障您的账户安全。
                </div>
                <div class="binding_desc" v-else>
                    您已绑定，绑定邮箱为：<span class="phone">{{ email }}</span>
                </div>
                <div class="binding_btn">
                    <a href="javascript:;" @click="mailBinding" v-if="this.email">修改</a>
                    <el-button @click="mailBinding" v-else>立即绑定</el-button>
                </div>
            </li>
            <li class="upgrade_item">
                <div class="account_icon">
                    <img src="@/assets/img/icon/is_certified.png" v-if="this.qq_bind">
                    <img src="@/assets/img/icon/no_certified.png" v-else>
                </div>
                <div class="account_binding">QQ绑定</div>
                <div class="binding_desc">
                    绑定QQ可以增强安全级别性，建议进行绑定。
                </div>
                <div class="binding_btn">
                    <!-- <a href="javascript:;">修改</a> -->
                    <el-button @click="qqBinding">立即绑定</el-button>
                </div>
            </li>
            <li class="upgrade_item">
                <div class="account_icon">
                    <img src="@/assets/img/icon/is_certified.png" v-if="this.wx_bind">
                    <img src="@/assets/img/icon/no_certified.png" v-else>
                </div>
                <div class="account_binding">微信绑定</div>
                <div class="binding_desc">
                    绑定微信可以增强安全级别性，建议进行绑定。
                </div>
                <div class="binding_btn">
                    <a href="javascript:;" v-if="1>2">修改</a>
                    <el-button>立即绑定</el-button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            phoneMask:'', //用户手机号
            email:'',     //用户邮箱
            qq_bind:'',   //用户QQ
            wx_bind:''    //用户微信
        }
    },
    computed:{
        // 个人信息
        info(){
            return this.$store.state.info
        }
    },
    created(){
        if(this.$store.state.info){
            this.initInfo()
        }else{
            this.needInfo("initInfo")
        }
    },
    methods:{
        /* 监测个人信息 */
        needInfo(fn) {
            let watchAch = this.$watch("info", (val, oldVal) => {
                if (val) {
                this[fn]();
                watchAch(); //取消监听
                }
            });
        },
        // 跳转修改密码
        changePassword(){
            this.$router.push({
                name:'personal_center_change_password'
            })
        },
        // 跳转修改手机号
        phoneBinding(){
            this.$router.push({
                name:'personal_center_phone_binding'
            })
        },
        // 跳转邮箱绑定
        mailBinding(){
            this.$router.push({
                name:'personal_center_mail_binding'
            })
        },
        // 跳转QQ绑定
        qqBinding(){
            this.$router.push({
                name:'personal_center_QQ_binding'
            })
        },
        // 初始化个人信息
        initInfo(){
            // 邮箱
            this.email = this.$store.state.info.email;
            // 绑定QQ
            this.qq_bind = this.$store.state.info.qq_bind;
            // 绑定微信
            this.wx_bind = this.$store.state.info.wx_bind;
            // 获取手机
            let phone = this.$store.state.info.mobile;
            this.phoneMask = `${phone.substring(0,3)}****${phone.substring(7)}`
        }
    },
}
</script>

<style lang="scss">
.safe_level{
    width:801px;
    height:141px;
    background:rgba(245,245,245,1);
    border-radius:6px;
    box-sizing: border-box;
    padding: 30px;  
    display: flex;
    justify-content: space-between;
    .safe_level_msg{
        .level{
            display: flex;
            align-items: center;
            margin-top: 8px;
            .level_tit{
                font-size:14px;
                color:rgba(75,80,98,1);
            }
            .level_line{
                .safe{
                    background:rgba(212,40,45,1);
                }
                span{
                    display: inline-block;
                    width:87px;
                    height:19px;
                    background:rgba(232,232,232,1);
                    margin-right: 5px;  
                }
            }
        }
        .text{
            font-size:14px;
            color:rgba(153,153,153,1);
            line-height: 55px;
            margin-top: 16px;
        }
    }
    .safe_level_img{
        img{
            width:143px;
            height:82px;
        }
    }
}
.pwd_upgrade{
    margin-top: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    .upgrade_item{
        display: flex;
        line-height: 99px;
        border-bottom: 1px dashed rgba(229,232,237,1);
        .account_icon{
            margin-right: 20px;
            margin-top: 6px; 
        }
        .account_binding{
            font-size:14px;
            color:rgba(75,80,98,1);
            width: 95px;
            // margin-right: 30px;
        }
        .binding_desc{
            // margin-right: 40px;
            font-size:14px;
            color:rgba(158,162,179,1);
            width: 610px;
            .phone{
                color: #D4282D;
            }
        }
        .binding_btn{
            a{
                font-size:14px;
                color:rgba(50,130,255,1);
            }
        }
    }
    .upgrade_item:last-of-type{
        border-bottom: none;
    }
}
</style>